import {
    FETCH_LOGGED_USER, FETCH_LOGGED_USER_SUCCESS, FETCH_LOGGED_USER_FAILURE,
} from '../actions/types';

const initialState = {
    isLoading: false
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_LOGGED_USER:
            return {
                ...state,
                isLoading: true
            };

        case FETCH_LOGGED_USER_SUCCESS:
            return {
                ...state,
                payload: action.payload,
                isLoading: false
            };

        case FETCH_LOGGED_USER_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
            
        default:
            return state;
    }
}

export default reducer;